<template>
  <div 
    class="relative inline-block min-h-[10px]"
  >
    <!-- Text content -->
    <div 
      ref="textContainer"
      class="relative z-10 inline-flex flex-wrap items-center gap-0 leading-tight"
      :style="{ color: textColor }"
    >
      <span
        v-for="(char, index) in text"
        :key="index"
        @mousemove="handleMouseMoveSpan(index)"
        @mouseleave="resetEffectSpan(index)"
        class="relative inline-block"
        :class="{ 'glow': haloText[index], 'after-glow': haloText2[index] }"
      >
        {{ char === ' ' ? ' ' : char }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: '#000'
  },  
  haloColor: {
    type: String,
    default: '#4F46E5'
  },  
  effectSize: {
    type: Number,
    default: 50
  }
});

const textContainer = ref(null);
const charPositions = ref([]);

const textColor = computed(() => props.color);

let rafId = null;

const haloText = ref([])
const haloText2 = ref([])
const handleMouseMoveSpan = (i) => {
  // console.log('handleMouseMoveSpan');
  haloText.value[i] = true
  // console.log('haloText[i]', haloText.value[i]);

}
const resetEffectSpan = (i) => {
  // haloText.value[i] = false;
  setTimeout(() => {
    haloText.value[i] = false;
    haloText2.value[i] = true
    setTimeout(() => {
      haloText2.value[i] = false
    }, 500);
  }, 300);
}

const updateCharPositions = () => {
  if (!textContainer.value) return;
  
  const spans = textContainer.value.querySelectorAll('span');
  charPositions.value = Array.from(spans).map(span => {
    const rect = span.getBoundingClientRect();
    return {
      left: rect.left,
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom
    };
  });
};

onMounted(() => {
  for (let index = 0; index < props.text.length; index++) {
    haloText.value.push(false)
  }
  // console.log('haloText', haloText.value);
  
  updateCharPositions();
  window.addEventListener('resize', updateCharPositions);
});
</script>

<style scoped>
span {
  transition: 1s ease all, text-shadow 1s ease;
  text-shadow: 0 0 30px #e6007300;
}
.after-glow {
  -webkit-animation: glow2 .5s ease-in-out infinite alternate;
  -moz-animation: glow2 .5s ease-in-out infinite alternate;
  animation: glow2 .5s ease-in-out infinite alternate;}
.glow {
  color: #a40e59;
  -webkit-animation: glow 0.5s ease-in-out infinite alternate;
  -moz-animation: glow 0.5s ease-in-out infinite alternate;
  animation: glow 0.5s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073, 0 0 70px #e60073;
  }
  to {
    text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6, 0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6, 0 0 80px #ff4da6;
  }
}
@keyframes glow {
  from {
    text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #e60073, 0 0 40px #e60073, 0 0 50px #e60073, 0 0 60px #e60073, 0 0 70px #e60073;
  }
  to {
    text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6, 0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6, 0 0 80px #ff4da6;
  }
}
@keyframes glow2 {
  from {
    text-shadow: 0 0 20px #fff, 0 0 30px #ff4da6, 0 0 40px #ff4da6, 0 0 50px #ff4da6, 0 0 60px #ff4da6, 0 0 70px #ff4da6, 0 0 80px #ff4da6;
  }
  to {
    text-shadow: 0 0 10px #ffffff00;
  }
}
</style> 
